import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { uiRequestOverlayReset, printDataUpdateRequest, updateWeekProgramFlyerSettings, bulkAddWeekProgramFlyerMovie, printDataWeekProgramPdfRequest, printDataWeekProgramPdfReset } from '../../../actions'
import toJS from '../../../hoc/toJS'
import { CLI_CINEMA_CLIENT_ID, CLI_CURRENT_CINEMA_ID, CLI_MULTICINEMA_MODE, FEATURES, PROGRAM_CINEMAS, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_PERFORMANCES, UI_GENERAL, UI_PROGRAM, WEEK_PROGRAM_FLYER_DATA } from '../../../constants/state'
import getData from '../../../functions/getData'
import PrintWeekProgramFlyer from '../present/PrintWeekProgramFlyer'

const mapStateToProps = state => ({
    requestOverlay: getData(state, [UI_GENERAL, 'requestOverlay']),
    features: getData(state, FEATURES),
    weekProgramFlyerData: getData(state, WEEK_PROGRAM_FLYER_DATA),
    movies:  getData(state, [PROGRAM_CLI_MOVIES_ITEMS]),
    order:  getData(state, [PROGRAM_CLI_MOVIES_ORDER]),
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    performances: getData(state, PROGRAM_PERFORMANCES),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE)
})

const mapDispatchToProps = (dispatch) => ({
    printWeekProgramFlyerRequest: (printFormatState, printFormat, landscape, activeWeek, printType, cinemaId) => {
        dispatch(printDataWeekProgramPdfRequest(printFormatState, printFormat, landscape, activeWeek, printType, cinemaId))
    },
    printUpdateRequest: () => {
        dispatch(printDataUpdateRequest())
    },
    updateWeekProgramFlyerSettings: (payload) => {
        dispatch(updateWeekProgramFlyerSettings(payload))
        dispatch(printDataUpdateRequest())
    },
    onPrintFlyerPdfResetState: () => {
        dispatch(printDataWeekProgramPdfReset())
        dispatch(uiRequestOverlayReset())
    },
    bulkAddWeekProgramFlyerMovie: (order) => {
        const items = {}
        order.forEach(movieId => {
            items[movieId] = {id: movieId}
        });
    
        dispatch(bulkAddWeekProgramFlyerMovie(items, order))
    }
})

const PrintWeekProgramFlyerContainer = ({
    params, 
    features,
    weekProgramFlyerData,
    printWeekProgramFlyerRequest, 
    printUpdateRequest,
    requestOverlay,
    onPrintFlyerPdfResetState,
    updateWeekProgramFlyerSettings,
    movies,
    order,
    currentCinemaId,
    performances,
    displayDropzones,
    multicinemaMode,
    currentClientCinemaId,
    bulkAddWeekProgramFlyerMovie,
    basicUrl,
    closePagePath
}) => {
    const { cinemaId, printType, printFormat, landscape, week } = params
    const { hasChanges, error, status, weekProgramFlyerSettings } = weekProgramFlyerData

    return (
        <PrintWeekProgramFlyer 
            cinemaId={cinemaId}
            printType={printType} 
            updateWeekProgramFlyerSettings={updateWeekProgramFlyerSettings} 
            weekProgramFlyerSettings={weekProgramFlyerSettings} 
            printID={printFormat}
            landscape={landscape} 
            requestStatus={status}
            requestError={error}
            currentClientCinemaId={currentClientCinemaId}
            multicinemaMode={multicinemaMode}
            requestOverlay={requestOverlay}
            activeWeek={week}
            hasChanges={hasChanges}
            displayDropzones={displayDropzones}
            movies={movies}
            order={order}
            currentCinemaId={currentCinemaId}
            performances={performances}
            features={features}
            weekProgramFlyerData={weekProgramFlyerData}
            printWeekProgramFlyerRequest={printWeekProgramFlyerRequest} 
            printUpdateRequest={printUpdateRequest}
            onPrintFlyerPdfResetState={onPrintFlyerPdfResetState}
            bulkAddWeekProgramFlyerMovie={bulkAddWeekProgramFlyerMovie}
            basicUrl={basicUrl}
            closePagePath={closePagePath}
      />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PrintWeekProgramFlyerContainer)